import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth.js';
import categories from './modules/categories.js';
import tags from './modules/tags.js';
import currencies from './modules/currencies.js';

Vue.use(Vuex);

const store = new Vuex.Store({ modules: { auth, categories, currencies, tags } });
export default store;
